<template>
  <div class="container">
    <app-header title="我的优惠券"></app-header>
    <!-- 分类 -->
    <div class="tabs">
      <div class="tab">
        <div class="item" v-for="(item,index) in tabList" :key="index">
          <div @click="handleTag(item)" :class="activeTag==item.id ? 'active':''">{{item.name}}</div>
        </div>
      </div>
    </div>
    <!-- 全部优惠券 -->
    <div>
      <template v-for="item in couponList">
        <!--全部-->
        <!--<div v-if="item.shopCoupon.statusEx==1" class="dueimg" :style="dueimg"  style="height: 115px; width: 95%;margin-left: 2%">-->
          <!--<div class="name" style="color: #DCDCDC">{{item.title}}</div>-->
          <!--<div class="price" style="color: #DCDCDC">￥{{item.money}}</div>-->
          <!--<div class="date">有效期：{{item.endTime}}</div>-->
        <!--</div>-->

        <!--未使用-->
        <div v-if="item.shopCoupon.statusEx==2" @click="$router.push('/category')">
          <div class="rechargeimg" :style="rechargeimg"  style="height: 115px; width: 95%;margin-left: 2%">
            <div class="name ellipsis">{{item.title}}</div>
            <div class="price">￥{{item.money}}</div>
            <div class="date">有效期：{{item.shopCoupon.endTime}}</div>
          </div>
        </div>

        <!--已使用-->
        <div v-if="item.shopCoupon.statusEx==3">
          <div class="dueimg" :style="usedimg"  style="height: 115px; width: 95%;margin-left: 2%">
            <div class="name ellipsis">{{item.title}}</div>
            <div class="price">￥{{item.money}}</div>
            <div class="date">有效期：{{item.shopCoupon.endTime}}</div>
          </div>
        </div>

        <!-- 已过期优惠券 -->
        <div v-if="item.shopCoupon.statusEx==4">
          <div class="dueimg" :style="dueimg"  style="height: 115px; width: 95%;margin-left: 2%">
            <div class="name ellipsis">{{item.title}}</div>
            <div class="price">￥{{item.money}}</div>
            <div class="date">有效期：{{item.shopCoupon.endTime}}</div>
          </div>
        </div>

      </template>
      <empty v-if="couponList.length === 0"/>
    </div>


  </div>
</template>

<script>
import { queryShopCouponList,myCoupon,useRecord } from '@/api/coupon/index.js'
export default {
  name: 'MyCoupon',
  data() {
    return {
      rechargeimg: {
        backgroundImage: 'url(' + require('@/assets/use.png') + ')',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        backgroundSize: '100% 100%',
        mozBackgroundSize: '100% 100%'
      },
      usedimg: {
        backgroundImage: 'url(' + require('@/assets/used.png') + ')',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        backgroundSize: '100% 100%',
        mozBackgroundSize: '100% 100%'
      },
      dueimg: {
        backgroundImage: 'url(' + require('@/assets/due.png') + ')',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        backgroundSize: '100% 100%',
        mozBackgroundSize: '100% 100%'
      },
      active: 1,
      activeTag: 1,
      serial: '1',
      tabList: [
        {id: 1,name: '全部'},
        {id: 2,name: '未使用'},
        {id: 3,name: '已使用'},
        {id: 4,name: '已过期'},
      ],
      couponList: []
    }
  },
  created() {
    this._queryShopCouponList()
  },
  methods: {
    // 优惠劵列表
    _queryShopCouponList() {
      var user = localStorage.getItem('userInfo')
      user = JSON.parse(user)
      const params = {
        uid: user.id,
        statusEx: this.serial
      }
      useRecord(params).then((res) => {
        if (res.success) {
          this.couponList = res.data
        }
      })
    },
    handleTag(item) {
      this.serial = item.id
      this.activeTag = item.id
      this._queryShopCouponList()
    },
    myCoupon() {
      this.$router.push('/myCoupon')
    }
  }
}
</script>

<style lang="less" scoped>
  .container{
    .tabs{
      display: flex;
      flex-direction: row;
      align-items: center;
      height:44px;
      padding: 0 12px;
      .tab{
        display: flex;
        flex-direction: row;
        flex: 1;
        justify-content: space-between;
        .item{
          font-size:14px;
          font-weight:500;
          height:22px;
          font-family:PingFang SC;
          line-height:22px;
          color:rgba(51,51,51,1);
          margin-right: 14px;
          .active{
            font-size:16px;
            font-weight:bold;
            color: #FE003B;
            border-bottom: 3px solid #FE003B;
          }
        }
      }
    }
    .name{
      width: 80%;
      font-size:18px;
      font-family:PingFang SC;
      font-weight:bold;
      line-height:25px;
      color:rgba(51,51,51,1);
      opacity:1;
      padding-top: 27px;
      text-align: center;
    }
    .price{
      width: 80%;
      font-size:18px;
      font-family:PingFang SC;
      font-weight:bold;
      line-height:25px;
      color:rgba(255,0,0,1);
      text-align: center;
    }
    .date{
      margin-top: 3px;
      font-size:12px;
      font-family:PingFang SC;
      font-weight:400;
      line-height:17px;
      color:rgba(204,204,204,1);
      opacity:1;
      margin-left: 15px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/mine/coupon/myCoupon.vue